var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar1"},[_c('KTQuickPanel'),_c('KTQuickUser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }